import PropTypes from 'prop-types'
import styled from 'styled-components'
import { t, jt } from 'ttag'

import { features } from '@h2/components/media'
import { SO, SO90T } from '@h2/components/colors'
import { Flex } from '@h2/components/layout/flex'
import { Box } from '@h2/components/layout/box'
import { Checklist } from '@h2/components/containers/checklist'
import { Heading } from '@h2/components/typography/heading'
import { Icon as IconComponent } from '@h2/components/display/icon'
import goalsSvg from '@h2/assets/svg/home/source/goals.svg'
import { Panel } from '@h2/common/components/panel'

import { WorkingWithOthers } from './workingWithOthers'

const Icon = styled(IconComponent)`
  margin: 0 0 0 18px;

  svg {
    clip-path: inset(0 36px 0 0);
  }
`
const WorkingBox = styled(Box)`
  display: none;

  @media (${features.minWidth.desktop}) {
    display: block;
    margin-left: 20px;
  }
`
const FlexWrap = styled(Flex)`
  @media (${features.minWidth.desktop}) {
    flex-direction: row;
    padding: 50px 0;

    h2 {
      font-size: 34px;
      margin-top: 0;
    }

    > div:first-child {
      span[role='img'] {
        margin: 0;
        color: white;

        svg {
          width: 342px;
          clip-path: unset;
        }
      }
    }

    > div:nth-child(2) {
      position: relative;
      top: -15px;
      left: -22px;

      ul {
        font-size: 20px;
        line-height: 24px;
      }
    }

    @media (${features.maxWidth.widescreen}) {
      > div:first-child {
        span[role='img'] {
          width: 300px;

          svg {
            width: 330px;
          }
        }
      }

      > div:nth-child(2) {
        left: -8px;
      }
    }
  }
`
const onTrack = <span key="track">{t`goal on track`}</span>
const GoalOnTrack = ({ systemName }) => {
  return (
    <Panel color="responsive">
      <FlexWrap direction="column" alignItems="center" padding="30px 20px">
        <Box>
          <Icon
            isCentered
            label="goals"
            color={SO90T}
            width="270px"
            height="auto"
            dangerouslySetGlyph={goalsSvg}
          />
        </Box>
        <Box>
          <Heading
            level="2"
            weight="light"
            mb="15px"
            mt="20px"
            mark="span"
            markColor={SO}
            variant="mixed-weight">
            {jt`Keep your ${onTrack}`}
          </Heading>
          <Heading level="4" mb="15px" variant="font" weight="bold">
            {t`Your ${systemName} account gives you the ability to:`}
          </Heading>
          <Box px="5px">
            <Checklist variant="leading-down">
              <Checklist.Item>{t`Save the items you explore`}</Checklist.Item>
              <Checklist.Item>
                {t`Create collections of items to keep you organized`}
              </Checklist.Item>
              <Checklist.Item>
                {t`Take notes and save files to document your journey`}
              </Checklist.Item>
            </Checklist>
          </Box>
        </Box>
        <WorkingBox>
          <WorkingWithOthers type="goal" shade="orange" size="small" />
        </WorkingBox>
      </FlexWrap>
    </Panel>
  )
}

GoalOnTrack.propTypes = {
  systemName: PropTypes.string.isRequired
}

export { GoalOnTrack }
